
import Vue from 'vue'

const locales = {keys(){return []}}
global['____E03A811____'] = true;
delete global['____E03A811____'];
global.__uniConfig = {"easycom":{"ci-(.*)":"@/components/ci-$1/index.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"globalStyle":{"navigationStyle":"custom","navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black","navigationBarTitleText":"","backgroundColor":"#F8F8F8","titleView":false}};
global.__uniConfig.compilerVersion = '4.29';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__E03A811';
global.__uniConfig.appName = '服务平台';
global.__uniConfig.appVersion = '0.0.1';
global.__uniConfig.appVersionCode = '1';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-customer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/customer/index"+'.vue')), 'pages-customer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-application-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/application/index"+'.vue')), 'pages-application-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/home/index"+'.vue')), 'pages-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-customerPortrait-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/customerPortrait/index"+'.vue')), 'pages-customerPortrait-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-quickReply-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/quickReply/index"+'.vue')), 'pages-quickReply-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-quickReply-create', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/quickReply/create"+'.vue')), 'pages-quickReply-create'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-collect-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/collect/index"+'.vue')), 'pages-collect-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-regular-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/regular/index"+'.vue')), 'pages-regular-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-browse-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/browse/index"+'.vue')), 'pages-browse-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/points/index"+'.vue')), 'pages-points-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wallet-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/wallet/index"+'.vue')), 'pages-wallet-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/pages/order/index"+'.vue')), 'pages-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('adminpages-authorization-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/adminpages/authorization/index"+'.vue')), 'adminpages-authorization-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('adminpages-admin-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/adminpages/admin/index"+'.vue')), 'adminpages-admin-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('adminpages-portrait-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("J:/git/mobile-middleground/src/adminpages/portrait/index"+'.vue')), 'adminpages-portrait-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/customer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-customer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-customer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/customer/index',
  windowTop:0
}
},
{
path: '/pages/application/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-application-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-application-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/application/index',
  windowTop:0
}
},
{
path: '/pages/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/index',
  windowTop:0
}
},
{
path: '/pages/customerPortrait/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户画像"})
      },
      [
        createElement('pages-customerPortrait-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-customerPortrait-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/customerPortrait/index',
  windowTop:0
}
},
{
path: '/pages/quickReply/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"快捷回复"})
      },
      [
        createElement('pages-quickReply-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-quickReply-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/quickReply/index',
  windowTop:0
}
},
{
path: '/pages/quickReply/create',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新建话术"})
      },
      [
        createElement('pages-quickReply-create', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-quickReply-create',
  isNVue:false,maxWidth:0,
  pagePath:'pages/quickReply/create',
  windowTop:0
}
},
{
path: '/pages/collect/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收藏品种"})
      },
      [
        createElement('pages-collect-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-collect-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/collect/index',
  windowTop:0
}
},
{
path: '/pages/regular/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"常购商品"})
      },
      [
        createElement('pages-regular-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-regular-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/regular/index',
  windowTop:0
}
},
{
path: '/pages/browse/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"浏览记录"})
      },
      [
        createElement('pages-browse-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-browse-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/browse/index',
  windowTop:0
}
},
{
path: '/pages/points/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分余额"})
      },
      [
        createElement('pages-points-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points/index',
  windowTop:0
}
},
{
path: '/pages/wallet/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"钱包余额"})
      },
      [
        createElement('pages-wallet-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wallet-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wallet/index',
  windowTop:0
}
},
{
path: '/pages/order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单管理"})
      },
      [
        createElement('pages-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/index',
  windowTop:0
}
},
{
path: '/adminpages/authorization/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('adminpages-authorization-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'adminpages-authorization-index',
  isNVue:false,maxWidth:0,
  pagePath:'adminpages/authorization/index',
  windowTop:0
}
},
{
path: '/adminpages/admin/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('adminpages-admin-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'adminpages-admin-index',
  isNVue:false,maxWidth:0,
  pagePath:'adminpages/admin/index',
  windowTop:0
}
},
{
path: '/adminpages/portrait/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('adminpages-portrait-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'adminpages-portrait-index',
  isNVue:false,maxWidth:0,
  pagePath:'adminpages/portrait/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
